import React, { useState, useEffect } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";

function CreatePlaceholder({
  onPopupStateChange,
  selectedTag,
  buttonTag,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible("CreatePlaceholderVisibility");

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isVisible);
    }
  }, [isVisible]);

  if (selectedTag && selectedTag !== buttonTag) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-folder-image fa-fw"></i>
        </div>
        <div className="button-card__title">Create Placeholder</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="videobolt-tools">
          <div
            onClick={() =>
              handleClick("createPlaceholderPremiere", { color: [1, 1, 1, 1] })
            }
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-sun-bright"></i>
            <span>Light</span>
          </div>
          <div
            onClick={() =>
              handleClick("createPlaceholderPremiere", {})
            }
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-moon"></i>
            <span className="render-group__button-text">Dark</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreatePlaceholder;
